'use client';

import { useState, useEffect } from 'react';

export function MobileWarning() {
  const [isMobile, setIsMobile] = useState(false);
  const [tooSmall, setTooSmall] = useState(false);

  useEffect(() => {
    const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const check = () => {
      const narrow = window.innerWidth < 768;
      setIsMobile(touch && narrow);
      setTooSmall(!touch && narrow);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (!isMobile && !tooSmall) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-surface flex items-center justify-center p-8">
      <div className="text-center max-w-[320px]">
        <div className="text-amber text-[32px] mb-4">&#x1F41C;</div>
        <h1 className="text-amber font-bold text-[16px] mb-3 tracking-wider">SWARM</h1>
        {isMobile ? (
          <>
            <p className="text-secondary text-[13px] leading-[1.7] mb-4">
              This challenge requires a code editor and simulation viewer
              that need a desktop-sized screen.
            </p>
            <p className="text-primary font-bold text-[13px]">
              Please visit on a desktop browser.
            </p>
          </>
        ) : (
          <>
            <p className="text-secondary text-[13px] leading-[1.7] mb-4">
              The editor needs a bit more room to breathe.
            </p>
            <p className="text-primary font-bold text-[13px]">
              Please widen your browser window.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
